// extracted by mini-css-extract-plugin
export default {"legend":"Form_legend__WDkBY","footerStart":"Form_footerStart__pIFZE","footerEnd":"Form_footerEnd__wUTxw"};